import React, { useState, useEffect } from "react";
import global from "../../global-variables";
import Header from "../layout/header";
import { Link, useNavigate } from "react-router-dom";
import { FaEllipsisH, FaRegImage, FaLink ,FaVideo , FaRegFilePdf} from "react-icons/fa";
import $ from "jquery";
import WOW from "wowjs";

import { Container, Row, Col } from "reactstrap";
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import globalVariables from "../../global-variables";
import FsLightbox from "fslightbox-react";
import Metatag from '../../hooks/Metatag'
import { GetEventList,GetPastEventList } from "../../api/events-functions";
import { GetEventTypeDistinctYearList } from "../../api/event-type-distinct-year-functions";
import {GetEventsGalleryList} from "../../api/events-gallery-functions";



export default function Events() {
  const [toggler, setToggler] = useState(false);
  const [index, setIndex] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    // add class for home header and remove inner class
    $(".fixed-top").addClass("bg-header");


  }, []);

    const [events, setEventsList] = useState([]);
  
    const [eventname, setEventsName] = useState(null);
    const [eventtypeyear, setEventTypeYearList] = useState(null);

    // success function when the list is retrived
    const OnGetEventSuccess = (p_response) => {
      // set the list for looping
      setEventsList(p_response);
  }
  

  const [pastEventList ,setPastEventList] = useState(null);
  
  
  const onGetPastEventSuccess = (p_response) => {
    setPastEventList(p_response)
  }

  const OnGetEventTypeYearSuccess = (p_response) => {

      // set the list for looping
      setEventTypeYearList(p_response);

      setTimeout(() => {
          // get the current event dropdown list
          let _ddlYear = document.getElementById("ddlEventYear");


          // bind the on change event to the dropdown list
          _ddlYear.onchange = (e) => {

               // gettting past event list 
             let _obj = new Object();

             _obj.event_status = 1;
             _obj.pastEvent = "p";
             _obj.selected_year = e.target.value;
             _obj.event_status = 1
             // call the function to get the roadblock
             GetPastEventList(_obj,onGetPastEventSuccess,navigate);
              
          };


          // call the onchange event for loading the news for the first time
          // Create a new 'change' event
          var event = new Event('change');

          // Dispatch it.
          _ddlYear.dispatchEvent(event);
      }, 100);

  }

  useEffect(()=>{
    
    //getting upcoming event list
    let _objEvent = new Object();

    _objEvent.event_status = 1;
    _objEvent.event_upcoming = "u";
    // call the function to get the event
    GetEventList(_objEvent,OnGetEventSuccess,navigate);
  },[])
 
  const [events_gallery_toggler, setEventsGalleryToggler] = useState(false);
    const [events_gallery, setEventsGallery] = useState([]);
    const [events_gallery_titel, setEventsGalleryTitel] = useState([]);

    const [gallery_key, setGalleryKey] = useState("");

    const [videos, setvideosToggler] = useState(false);

    const [lightbox_video, setLightBoxVideo] = useState([]);

        // success function when events gallery is retrived
        const OnGetEventsGallerySuccess = (p_response) => {

            // let _arrGallery = [];

            // // loop and make the array for binding the gallery
            // for (let i = 0; i < p_response.length; i++) {
            //     _arrGallery.push(globalVariables.variables.strApiUrl + "/events-gallery-image/" + p_response[i].egallery_pic);
            // }

            // set the array in the constant
            setEventsGallery(p_response);

            setGalleryKey(Date.now())

            // using time out for the value to get saved in state
            setTimeout(() => {
                // trigger the link click to display the news gallery popup
                document.getElementById("lnk_trigger_events_gallery_popup").click();
            }, 200);

        }


        // function to invoke photo gallery
        const InvokePhotoGallery = (e, p_event_id) => {
            e.preventDefault();

            // Make an object for getting news gallery
            let _objEventsGallery = new Object();
            _objEventsGallery.egallery_status = 1;
            _objEventsGallery.egallery_event_id = p_event_id;

            // call the function to get the news gallery
            GetEventsGalleryList(_objEventsGallery, OnGetEventsGallerySuccess,navigate);

        };

         // function to invoke video popup
         const InvokeVideoPopup = (e, p_event_video_url) => {

            e.preventDefault();

            let _arrVideos = [];
            _arrVideos.push(p_event_video_url);

            // set the path to the constant for displaying
            setLightBoxVideo(_arrVideos);

            // trigger the link click to display the popup
            document.getElementById("lnk_trigger_video_popup_event").click();

        };


    // things to be done when the page is loaded
    useEffect(() => {

        //make the object for getting the news type year list
        let _objEventTypeYear = new Object();
        _objEventTypeYear.event_status = 1;
        _objEventTypeYear.site = 'y'
        // call the function to get the news type year list
        GetEventTypeDistinctYearList(_objEventTypeYear, OnGetEventTypeYearSuccess,navigate)
    }, []);

    useEffect(()=>{
      
      // initiate the wow effect
      new WOW.WOW({
        live: false,
      }).init();
    
    },[events,pastEventList])

    
  return (
    <>
      <Header main_className="bg-header"></Header>
      {/* Metatag  */}
      <Metatag title='NDMC Events | NDMC Workshops | NDMC Seminars'  
                        keywords='NDMC Events, NDMC Workshops, NDMC Seminars, NDMC IIT-B Events, NDMC IIT-B Workshops, NDMC IIT-B Seminars, Disease Modelling Events, Disease Modelling Workshops, Disease Modelling Seminars' 
                        description='Events, Workshops and Seminars organized by National Disease Modelling Consortium (NDMC) based in IIT Bombay'
                        />
      <Container fluid className="px-0 bg-visual position-relative" style={{ backgroundImage: "url('./images/bg-events.jpg')", backgroundSize: "cover", backgroundRepeat: "no-repeat", backgroundPosition: "center" }}>
        <img src={global.variables.strDomainUrl + "images/bg-blank.png"} alt="" title="" className="w-100" />
        <div className="masthead d-flex align-items-center w-100">
          <Container className="px-4 px-md-5 pb-xl-5 py-4">
            <div className="d-flex align-items-end">
              <div className="m-0 d-sm-flex align-items-center">
                <h1 className="mb-0 fw-bold text-white text-uppercase">EVENTS/WORKSHOPS</h1>
                
              </div>
            </div>
          </Container>
        </div>
      </Container>
      {
        eventtypeyear != null ?
          <Container className="p-md-5 p-4 content-bg bordr bg-white rounded-3 shadow-sm bg-panels events">
              {
              
                  events.length > 0 ?
                  <>
                    <h2 className="text-danger fw-bold mb-4 px-3">Upcoming Events/Workshops</h2>
                    <Row className="row-cols-1 g-4 upcoming-events">
                      
                        {
                            events.map((val)=>{
                              return(
                                        <Col className="px-md-3">
                                          <div className="d-md-flex h5 px-3">
                                            
                                          {
                                            //check for the equal date 
                                            val.event_from_date === val.event_to_date ?
                                            <div style={{ minWidth: "140px" }}>
                                              <p className="date text-danger mb-0 fw-bold">{val.event_from_date}:</p>
                                            </div>
                                          :
                                            <div style={{ minWidth: "260px" }}>
                                              <p className="date text-danger mb-0 fw-bold">{`${val.event_from_date} to ${val.event_to_date}`}:</p>
                                            </div>
                                          }
                                          
                                            <div className="flex-grow-1">
                                                <p className="text-dark mb-0">{val.event_name}</p>
                                            </div>
                                          {
                                            val.event_url != "" && val.event_url != null ? 
                                              <div style={{ minWidth: "60px" }}>
                                                
                                                <Link to={val.event_url} target="_blank" className="btn btn-list btn-slide rounded-pill py-1" data-toggle="tooltip" title="" data-original-title="Details"
                                                data-bs-original-title="" style={{cursor: "pointer", color : "white"}}>
                                                <FaLink />
                                                </Link>
                                                
                                              </div>
                                            :
                                              null
                                          }
                                          </div>
                                        </Col> 
            
                            )
                          })
                        }
                           
                    </Row>
                    <hr className="my-5" />
                  </>
                  :
                    null
              }
                <div class="d-inline-block m-0 d-flex  align-self-end py-lg-3 p-2">
                  <h2 className="text-danger fw-bold px-3 mb-4">Past Events/Workshops </h2>
                  <div className="ms-md-2 ms-sm-1 d-inline-block">
                  {
                        eventtypeyear.length > 0 ?
                            <select aria-label="Default select example" className="shadow-none form-select" id="ddlEventYear">
                                {
                                    eventtypeyear.map((val) => {
                                        return (

                                            <option value={val.event_year} key={val.event_year}>{val.event_year}</option>
                                        )
                                    })
                                }
                            </select>
                            :
                            <select aria-label="Default select example" className="shadow-none form-select" id="ddlEventYear">
                              <option value={new Date().getFullYear()}>{new Date().getFullYear()}</option>
                            </select>
                      }
                  </div>
                  
                </div>
                
                  
                
              {
                pastEventList != null ?
                  pastEventList.length > 0 ?
                  <>
                    <Row className="row-cols-lg-3 row-cols-md-2 row-cols-1 g-3 g-lg-4 g-xxl-4 px-3">
                      {
                        pastEventList.map((val)=>{
                         
                          return(
                              <Col>
                                <div className="box p-xl-3 p-2 d-md-flex flex-column rounded-3 overflow-hidden h-100">
                                  <div className="h-100">
                                    {
                                      val.event_details != null && val.event_details != "" ? 
                                        <Link to={globalVariables.variables.strDomainUrl + "events-detail/" + val.event_pagename}>
                                          <div className="eve-pic position-relative overflow-hidden rounded-2 wow fadeInUp">
                                            {
                                              val.event_thumbnail != "" && val.event_thumbnail != null ?
                                                <figure className="overflow-hidden rounded-2 m-0">
                                                  <img src={global.variables.strApiUrl + "/events-main-image/" + val.event_thumbnail} className="img-fluid rounded-2 p-1 bg-white" alt={val.event_name} title={val.event_name} />
                                                </figure>
                                              :
                                              <figure className="overflow-hidden rounded-2 m-0">
                                                  <img src={global.variables.strDomainUrl + "images/default-thumb.jpg"} className="img-fluid rounded-2 p-1 bg-white" />
                                                </figure>
                                            }
                                          </div>
                                          <div className="eve-info py-2 px-xl-2 px-2 wow fadeInUp">
                                            <h6 className="text-dark mb-0">
                                              {val.event_name}
                                            </h6>
                                            {
                                              //check for the equal date 
                                              val.event_from_date === val.event_to_date ?
                                                <p className="date mb-0">{val.event_from_date}</p>
                                                :
                                                <p className="date mb-0">{`${val.event_from_date} to ${val.event_to_date}`}</p>
                                              }

                                          </div>
                                        </Link>
                                      :
                                      <div>
                                      <div className="eve-pic position-relative overflow-hidden rounded-2 wow fadeInUp">
                                        {
                                          val.event_thumbnail != "" && val.event_thumbnail != null ?
                                            <figure className="overflow-hidden rounded-2 m-0">
                                              <img src={global.variables.strApiUrl + "/events-main-image/" + val.event_thumbnail} className="img-fluid rounded-2 p-1 bg-white" alt={val.event_name} title={val.event_name} />
                                            </figure>
                                          :
                                          <figure className="overflow-hidden rounded-2 m-0">
                                              <img src={global.variables.strDomainUrl + "images/default-thumb.jpg"} className="img-fluid rounded-2 p-1 bg-white" />
                                            </figure>
                                        }
                                      </div>
                                      <div className="eve-info py-2 px-xl-2 px-2 wow fadeInUp">
                                        <h6 className="text-dark mb-0">
                                          {val.event_name}
                                        </h6>
                                        {
                                          //check for the equal date 
                                          val.event_from_date === val.event_to_date ?
                                            <p className="date mb-0">{val.event_from_date}</p>
                                            :
                                            <p className="date mb-0">{`${val.event_from_date} to ${val.event_to_date}`}</p>
                                          }

                                      </div>
                                      </div>
                                    }
                                  </div>
                                  <div>
                                    <ul className="news-gal px-xl-2 px-2 mt-aut0">
                                        {
                                          parseInt(val.event_gallery_count) > 0 ?
                                            <li className="btnlist wow fadeInUp">
                                              <Link onClick={event => InvokePhotoGallery(event, val.event_id)} className="fancybox-media btn btn-slide rounded-pill py-1 px-3">
                                                <FaRegImage className="icon-20" />
                                              </Link>
                                            </li>
                                          :
                                            null
                                        }
                                        {
                                        val.event_details != null && val.event_details != "" ? 
                                          <li className="btnlist wow fadeInUp">
                                            <Link to={globalVariables.variables.strDomainUrl + "events-detail/" + val.event_pagename}
                                              className="btn btn-slide rounded-pill py-1" data-toggle="tooltip" title=""
                                              data-original-title="Details" data-bs-original-title="">
                                              <FaEllipsisH />
                                            </Link>
                                          </li>
                                        :
                                          null
                                        }
                                      {
                                        val.event_url != null && val.event_url != "" ?
                                          <li className="btnlist wow fadeInUp">
                                            <Link to={val.event_url}
                                              target="_blank" className="btn btn-slide rounded-pill py-1"
                                              data-toggle="tooltip" title="" data-original-title="Details"
                                              data-bs-original-title="">
                                              <FaLink />
                                            </Link>
                                          </li>
                                        :
                                          null
                                      }
                                      {/* Video */}
                                      { 
                                        val.event_video_link != null && val.event_video_link != "" ?
                                        <li className="btnlist wow fadeInUp">
                                          <Link className="btn btn-slide rounded-pill py-1" onClick={event => InvokeVideoPopup(event, val.event_video_link)}><FaVideo/></Link>
                                        </li>
                                        :
                                          null
                                      }
                                      {/* Document */}
                                      {
                                          val.event_document != null && val.event_document != "null" && val.event_document != "" ?
                                          <li className="btnlist wow fadeInUp">
                                            <a className="btn btn-slide rounded-pill py-1" href={globalVariables.variables.strApiUrl + "/events-documents/" + val.event_document} target="_blank" ><FaRegFilePdf /></a>
                                          </li>
                                          :
                                            null
                                      }
                                    </ul>
                                  </div>
                                </div>
                              </Col>
                          )
                        })
                      }
                    </Row>
                  
                  </>
                  :
                  <Row >
                    <span className="text-center fw-bold">No records found</span>
                  </Row>
                :
                <Row >
                    <span className="text-center">Loading...</span>
                  </Row>
              }

          </Container >
        :
        <Container className="p-md-5 p-4 content-bg bordr bg-white rounded-3 shadow-sm events">
          <Row className="box p-xl-4 p-2 rounded-3">
            <span className="text-center">Loading...</span>
          </Row>
        </Container>
      }
          {/* events Gallery popup */}
            {/* this link will open the news gallery popup which will be hidden because the button from the grid is causing issue */}
            <a onClick={(e) => {
                e.preventDefault();
                setEventsGalleryToggler(!events_gallery_toggler);
            }}
                className="d-none"
                id="lnk_trigger_events_gallery_popup"></a>

            <FsLightbox
        toggler={events_gallery_toggler}
        sources={events_gallery?.map((item) => {
          return (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
              }}
              key={item.egallery_id}
              className="fsDiv"
            >
              <img
                className="img-fluid"
                src={`${globalVariables.variables.strApiUrl}/events-gallery-image/${item.egallery_pic}`}
                alt={item.egallery_title}
                style={{ objectFit: "contain" }}
              />
              <p
                style={{
                  textAlign: "center",
                  color: "white",
                  fontSize: "16px",
                }}
              >
                {item.egallery_title}
              </p>
            </div>
          );
        })}
        key={gallery_key}
      />

             {/* Video popup */}
            {/* this link will open the video popup which will be hidden because the button from the grid is causing issue */}
            <a onClick={(e) => {
                e.preventDefault();
                setvideosToggler(!videos);
            }}
                className="d-none"
                id="lnk_trigger_video_popup_event"></a>

            <FsLightbox
                toggler={videos}
                sources={lightbox_video}
            />

      {/* Breadcrumb */}
      <Container  fluid className="small pt-3 p-0 bg-white d-flex justify-content-center mt-auto" >
        <Breadcrumb>
          <Breadcrumb.Item href={global.variables.strDomainUrl}>Home</Breadcrumb.Item>
          <Breadcrumb.Item active>Events/Workshops</Breadcrumb.Item>
        </Breadcrumb>
      </Container>
      {/* Breadcrumb */}
    </>
  );
}